<template>
	<div class="mt-20 text-center">
		<p class="text-6xl">Accediendo al Cloud</p>
		<p class="text-4xl">Por favor espere</p>
	</div>
</template>

<script>
export default {
	mounted() {
		const vuex = JSON.parse(localStorage.getItem('vuex'))

		if (!vuex || !vuex.login || !vuex.login.token) {
			window.location = window.location.origin + '/login' + window.location.search
		}

		const urlParams = new URLSearchParams(window.location.search)

		const payload = {
			response_type: urlParams.get('response_type'),
			client_id: urlParams.get('client_id'),
			redirect_uri: urlParams.get('redirect_uri'),
			scope: urlParams.get('scope'),
			state: urlParams.get('state'),
			token: vuex.login.token,
		}

		this.$axios
			.post(process.env.VUE_APP_OAUTH_URL, payload)
			.then(response => {
				window.location = response.data.redirect_url
			})
			.catch(error => {
				if (error.response.status === 401) {
					this.$store.dispatch('login/logout')
				}
			})
	},
}
</script>
